// FAQ accordion from the homepage (.faq-q buttons toggle the panel named by aria-controls).
export function initFaq(scope = document) {
  scope.querySelectorAll(".faq-q").forEach((btn) => {
    if (btn.dataset.faqBound) return;
    btn.dataset.faqBound = "1";
    btn.addEventListener("click", () => {
      const open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      const panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (panel) panel.hidden = open;
    });
  });
}
